export default {
  RECOMMENDED_INVESTMENT_PRODUCT_REPOSITORY: Symbol.for('RECOMMENDED_INVESTMENT_PRODUCT_REPOSITORY'),
  GET_RECOMMENDED_INVESTMENT_PRODUCT_QUERY: Symbol.for('GET_RECOMMENDED_INVESTMENT_PRODUCT_QUERY'),
  RECOMMENDED_INVESTMENT_PRODUCT_STATE_MANAGER: Symbol.for('RECOMMENDED_INVESTMENT_PRODUCT_STATE_MANAGER'),
};
